import React, { FC } from 'react';
import { default as LinkoTypes } from '@rcp/types';
import { History } from 'history';
import { localizationService } from 'src/services';
import FrequencySettingsComponent from '../../../shared/settings/frequencies/frequency-settings';

interface Props<T> extends LinkoTypes.RouteProps {
	history: History;
}

const CccFrequencySettingsComponent: FC<Props<any>> = props => {
	return (
		<div className="page">
			<div className="page-header">
				<h1>{localizationService.getLocalizedString('authoritySetting.frequency.frequencies')}</h1>
			</div>

			<div className="page-wrapper">
				<div className="main settings">
					<FrequencySettingsComponent history={props.history} match={props.match} />
				</div>
			</div>
		</div>
	);
};

export default CccFrequencySettingsComponent;
